module.exports = __webpack_public_path__ + "d6c136eb571a9da91274aac327c69b50.pdf";